"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PaymentManual = require("../../PaymentManual/PaymentManual");
var _payment = require("../../assets/icons/payment");
var _PaymentManualModule = _interopRequireDefault(require("../../PaymentManual/PaymentManual.module.css"));
var _Icon = require("../../Icon/Icon");
var _excluded = ["platform"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var entries = [{
  key: 'Lb',
  video: '//www.youtube.com/embed/p1yAi8xSxVY',
  map: null,
  content: /*#__PURE__*/_react.default.createElement("div", null, "Leader-bet")
}, {
  key: 'Lib',
  video: '',
  map: null,
  content: /*#__PURE__*/_react.default.createElement("div", null, "Liberty")
}, {
  key: 'Tbc',
  video: '',
  map: null,
  content: /*#__PURE__*/_react.default.createElement("div", null, "Tbc")
}];
var _default = function _default(_ref) {
  var platform = _ref.platform,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    videoSrc = _useState2[0],
    setVideoSrc = _useState2[1];
  var header = (0, _react.useCallback)(function (item) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      style: {
        textDecoration: 'underline',
        display: 'flex',
        marginRight: '1.8rem'
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      height: '2.5rem',
      width: '1.9rem',
      Icon: _payment.Map,
      style: {
        marginRight: '1rem'
      }
    }), "\u10E1\u10D0\u10DA\u10D0\u10E0\u10DD\u10D4\u10D1\u10D8"), /*#__PURE__*/_react.default.createElement("span", {
      onClick: function onClick(e) {
        e.stopPropagation();
        setVideoSrc(item.video);
      },
      style: {
        textDecoration: 'underline',
        display: 'flex',
        marginLeft: '1.8rem'
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      height: '3rem',
      width: '2.1rem',
      Icon: _payment.Video,
      style: {
        marginRight: '1rem'
      }
    }), "\u10D5\u10D8\u10D3\u10D4\u10DD \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0"));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!videoSrc ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    onClick: function onClick() {
      setVideoSrc(null);
      //setShowMap(false);
    },

    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      color: '#454A65',
      fontFamily: 'lbet-st',
      fontSize: '1.5rem',
      cursor: 'pointer',
      margin: '1.5rem',
      position: 'absolute',
      top: 0,
      right: 0,
      transform: 'translateY(-220%)'
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '1.9rem',
    width: '2.4rem',
    Icon: _payment.Back,
    style: {
      marginRight: '1rem'
    }
  }), "\u10E3\u10D9\u10D0\u10DC \u10D2\u10D0\u10E1\u10D5\u10DA\u10D0"), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      aspectRatio: '16/9',
      position: 'relative'
      /*height: '35rem',*/
    }
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    src: videoSrc,
    frameBorder: 0,
    allowFullScreen: true
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, entries.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_PaymentManual.PaymentManual, _extends({
      key: item.key,
      platform: platform,
      type: 'info'
    }, platform === 'web' && {
      header: header(item)
    }, {
      content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, platform === 'mob' && /*#__PURE__*/_react.default.createElement("div", {
        className: _PaymentManualModule.default.details,
        style: {
          justifyContent: 'space-around',
          width: 'calc(100% + 2.5rem)',
          marginLeft: '-1.25rem',
          marginBottom: '1.5rem',
          backgroundColor: '#F5F5F5',
          padding: '1rem',
          borderRadius: '4px'
        }
      }, header(item)), item.content),
      eventKey: item.key,
      logo: _payment.CashDeskLogos[item.key],
      style: {
        margin: '1rem 0'
      }
    }));
  })));
};
exports.default = _default;